module.exports = __webpack_public_path__ + "app-static/img/p_01.0a2e0edb.jpg";